// extracted by mini-css-extract-plugin
export default {"termsContainer":"terms_termsContainer__rrd8u"};